import { Grid, Typography, TextField, Button, Box } from '@mui/material';
import React from 'react';
import { motion } from 'framer-motion';
import banner from '../images/Bannerbanner.png';

const Banner = () => {
    const colleges = [
        "1. St. Joseph's Pre-University College",
        "2. Mount Carmel PU College",
        "3. Presidency PU College",
        "4. Bangalore Institute of Technology (BIT)",
        "5. Mallya Aditi International School PU College",
    ];

    return (
        <Grid
            container
            sx={{
                position: 'relative',
                backgroundImage: `url(${banner})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: { md: '85vh', sm: '70vh', xs: '85vh' },
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0, right: 0, bottom: 0, left: 0,
                    // Use a modern gradient overlay to make text pop while letting the image show
                    background: 'linear-gradient(90deg, rgba(26,35,126,0.85) 0%, rgba(26,35,126,0.6) 50%, rgba(26,35,126,0.3) 100%)',
                    zIndex: 1
                }
            }}
        >
            <Box sx={{ position: 'relative', zIndex: 2, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, width: '100%', p: { md: '0px 60px', xs: '40px 20px', sm: '40px' }, pt: { md: '80px', xs: '100px' } }}>
                {/* Left Section: College List */}
                <Grid item xs={12} md={7} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', pr: { md: 5 } }}>
                    <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
                        <Typography
                            variant='h1'
                            sx={{
                                fontSize: { md: '56px', xs: '36px', sm: '48px' },
                                color: '#ffffff',
                                fontWeight: 800,
                                mb: 2,
                                letterSpacing: '-0.5px',
                                textShadow: '0 4px 12px rgba(0,0,0,0.3)'
                            }}
                        >
                            <span style={{ color: 'var(--secondary-light)' }}>Top PU Colleges</span><br />
                        </Typography>
                    </motion.div>

                    <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }}>
                        <Typography sx={{ fontSize: { md: '20px', xs: '16px', sm: '18px' }, color: 'rgba(255,255,255,0.9)', mb: 4, lineHeight: 1.6, maxWidth: '600px' }}>
                            Excellent schooling that focuses on academics, extracurricular activities & career-focused programs,
                            giving students a solid basis for future ambitions.
                        </Typography>
                    </motion.div>

                    {/* List of Colleges */}
                    <Box component={motion.div} initial="hidden" animate="visible" variants={{
                        hidden: { opacity: 0 },
                        visible: { opacity: 1, transition: { staggerChildren: 0.1, delayChildren: 0.4 } }
                    }}>
                        <Grid container direction="column" spacing={1.5}>
                            {colleges.map((college, index) => (
                                <motion.div key={index} variants={{ hidden: { opacity: 0, x: -20 }, visible: { opacity: 1, x: 0 } }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                        <Box sx={{
                                            width: '8px', height: '8px', borderRadius: '50%',
                                            backgroundColor: 'var(--secondary-color)', mr: 2,
                                            boxShadow: '0 0 10px var(--secondary-color)'
                                        }} />
                                        <Typography
                                            sx={{
                                                fontSize: { md: '18px', xs: '16px', sm: '18px' },
                                                color: '#ffffff',
                                                fontWeight: 500,
                                            }}
                                        >
                                            {college.substring(3)}
                                        </Typography>
                                    </Box>
                                </motion.div>
                            ))}
                        </Grid>
                    </Box>
                </Grid>

                {/* Right Section: Form */}
                <Grid
                    item
                    xs={12}
                    md={4.5}
                    sx={{
                        display: { xs: 'none', md: 'flex' },
                        justifyContent: 'flex-end',
                        alignItems: 'center'
                    }}
                >
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.6, delay: 0.6 }}
                        style={{ width: '100%', maxWidth: '420px' }}
                    >
                        <Box sx={{
                            background: 'rgba(255, 255, 255, 0.95)',
                            backdropFilter: 'blur(12px)',
                            padding: { xs: 3, md: 4 },
                            borderRadius: '24px',
                            boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                            border: '1px solid rgba(255,255,255,0.5)',
                            position: 'relative',
                            overflow: 'hidden'
                        }}>
                            {/* Decorative accent */}
                            <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: '4px', background: 'linear-gradient(90deg, var(--primary-color), var(--secondary-color))' }} />

                            <Typography
                                variant="h5"
                                sx={{ color: 'var(--primary-dark)', mb: 1, fontWeight: 700, letterSpacing: '-0.5px' }}
                            >
                                Get Free Counseling
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{ color: 'text.secondary', mb: 3 }}
                            >
                                Let our experts guide your academic journey.
                            </Typography>

                            <form>
                                <TextField
                                    label="Full Name"
                                    variant="outlined"
                                    fullWidth
                                    sx={{ mb: 2.5, '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                                />
                                <TextField
                                    label="Phone Number"
                                    variant="outlined"
                                    fullWidth
                                    sx={{ mb: 2.5, '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                                />
                                <TextField
                                    label="Message"
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    rows={2}
                                    sx={{ mb: 3, '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
                                />
                                <Button
                                    variant='contained'
                                    sx={{
                                        background: 'linear-gradient(45deg, var(--primary-color), var(--primary-light))',
                                        color: '#fff',
                                        py: 1.5,
                                        fontSize: '1.1rem',
                                        fontWeight: 600,
                                        textTransform: 'none',
                                        borderRadius: '30px',
                                        boxShadow: '0 8px 16px rgba(26,35,126,0.3)',
                                        '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 12px 20px rgba(26,35,126,0.4)',
                                        }
                                    }}
                                    fullWidth
                                >
                                    Apply Now
                                </Button>
                            </form>
                        </Box>
                    </motion.div>
                </Grid>
            </Box>
        </Grid>
    );
};

export default Banner;
